/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'components/warning': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" _fill="#fff" d="M9 4H7v5h2V4zm-1 8a1 1 0 100-2 1 1 0 000 2z"/>'
  }
})
